// src/pages/admin/Commissions.jsx
import React, { useEffect, useState } from "react";
import { getDesigners, getCommissions, markPaid } from "../../lib/db";
import { StatCard, TableCard, Table, Badge, Btn, Toast, Spinner, SectionLabel, Avatar, fmt$, fmtDate } from "../../components/UI";

export default function Commissions() {
  const [designers, setDesigners]   = useState([]);
  const [history, setHistory]       = useState([]);
  const [loading, setLoading]       = useState(true);
  const [toast, setToast]           = useState("");

  const load = async () => {
    setLoading(true);
    const [d, c] = await Promise.all([getDesigners(), getCommissions()]);
    setDesigners(d); setHistory(c); setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleMarkPaid = async (designer) => {
    if (!designer.pendingPayout) return;
    await markPaid(designer.id, designer.pendingPayout);
    setToast(`Paid ${fmt$(designer.pendingPayout)} to ${designer.name}`);
    setTimeout(() => setToast(""), 3500);
    load();
  };

  const pendingDesigners = designers.filter(d => (d.pendingPayout || 0) > 0);
  const totalPending     = pendingDesigners.reduce((s, d) => s + (d.pendingPayout || 0), 0);
  const totalPaid        = designers.reduce((s, d) => s + (d.totalPaid || 0), 0);
  const totalEarned      = designers.reduce((s, d) => s + (d.ytdEarned || 0), 0);

  const pendingCols = [
    { key:"dName",    label:"Designer" },
    { key:"tier",     label:"Tier" },
    { key:"rate",     label:"Rate" },
    { key:"ytdSales", label:"YTD Sales" },
    { key:"pending",  label:"Pending Payout" },
    { key:"nextDate", label:"Next Payout" },
    { key:"actions",  label:"" },
  ];

  const pendingRows = pendingDesigners.map(d => ({
    dName: <div style={{display:"flex",alignItems:"center",gap:10}}><Avatar name={d.name} /><div><div style={{fontWeight:400}}>{d.name}</div><div style={{fontSize:11,color:"var(--mid)"}}>{d.firm}</div></div></div>,
    tier:     <Badge label={d.tier || "Partner"} />,
    rate:     `${d.commissionRate || 8}%`,
    ytdSales: fmt$(d.ytdSales),
    pending:  <span style={{color:"var(--gold)",fontWeight:500,fontFamily:"'Cormorant Garamond',serif",fontSize:18}}>{fmt$(d.pendingPayout)}</span>,
    nextDate: "May 1, 2026",
    actions:  <Btn variant="gold" size="sm" onClick={() => handleMarkPaid(d)}>Mark Paid</Btn>,
  }));

  const historyCols = [
    { key:"designer", label:"Designer" },
    { key:"amount",   label:"Amount" },
    { key:"date",     label:"Paid On" },
    { key:"status",   label:"Status" },
  ];

  const historyRows = history.map(c => {
    const d = designers.find(d => d.id === c.designerUid);
    return {
      designer: d ? <div style={{display:"flex",alignItems:"center",gap:10}}><Avatar name={d.name} size={24} />{d.name}</div> : c.designerUid,
      amount: <span style={{color:"var(--green)",fontWeight:400}}>{fmt$(c.amount)}</span>,
      date: fmtDate(c.paidAt),
      status: <Badge label="paid" />,
    };
  });

  return (
    <div>
      <Toast msg={toast} onClose={() => setToast("")} />
      <div style={{ padding:"36px 48px 0" }}>
        <h1 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:300 }}>Commissions</h1>
        <p style={{ fontSize:13, color:"var(--mid)", marginTop:4 }}>Track and process designer payouts</p>
      </div>
      <div style={{ padding:"24px 48px 48px" }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:16, marginBottom:28 }}>
          <StatCard label="Pending Payout"  value={fmt$(totalPending)} accent />
          <StatCard label="Paid This Year"  value={fmt$(totalPaid)} />
          <StatCard label="Total Earned YTD" value={fmt$(totalEarned)} />
          <StatCard label="Designers w/ Balance" value={pendingDesigners.length} />
        </div>

        <SectionLabel>Pending Payouts</SectionLabel>
        <TableCard>
          {loading ? <Spinner /> : <Table cols={pendingCols} rows={pendingRows} emptyMsg="No pending payouts — all designers are paid up!" />}
        </TableCard>

        <SectionLabel>Payment History</SectionLabel>
        <TableCard>
          {loading ? <Spinner /> : <Table cols={historyCols} rows={historyRows} emptyMsg="No payments recorded yet." />}
        </TableCard>
      </div>
    </div>
  );
}
